// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  receiptId: __t.u64().primaryKey().name("receipt_id"),
  owner: __t.identity(),
  actor: __t.identity(),
  kind: __t.string(),
  stationKey: __t.string().name("station_key"),
  familyKey: __t.string().name("family_key"),
  requested: __t.u32(),
  filled: __t.u32(),
  costSov: __t.i64().name("cost_sov"),
  brokerSov: __t.i64().name("broker_sov"),
  escrowSov: __t.i64().name("escrow_sov"),
  refundSov: __t.i64().name("refund_sov"),
  detailJson: __t.string().name("detail_json"),
  note: __t.string(),
  at: __t.timestamp(),
});
